var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcFilter = function SvgIcFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#24262B",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M14 8H5.986M3.157 8H2m1.157 0a1.414 1.414 0 1 1 2.828 0 1.414 1.414 0 0 1-2.828 0ZM14 12.285h-3.728m0 0a1.416 1.416 0 0 1-2.415 1 1.41 1.41 0 0 1-.414-1m2.829 0a1.414 1.414 0 0 0-2.83 0m0 0H2m12-8.57h-2.014m-2.829 0H2m7.157 0a1.414 1.414 0 1 1 2.828 0 1.414 1.414 0 0 1-2.828 0Z"
  })));
};
export default SvgIcFilter;